import type * as Bible from "./bible";

let hostNode: Node | undefined;

export type EventMap = {
  loaded: {
    query: string;
    translation: number;
  };
  loaderror: {
    query: string;
    translation: number;
  };
  linktapped: {
    link: Bible.ContentLinkPayload;
  };
  ready: {};
  translationtoggled: {
    expanded: boolean;
    translation: Bible.TranslationPayload;
  };
  versetapped: {
    id: number;
    reference: string;
    verse?: Promise<Bible.VersePayload>;
  };
};

export function dispatchEvent<K extends keyof EventMap>(
  event: K,
  payload: EventMap[K],
) {
  if (hostNode) {
    hostNode.dispatchEvent(
      new CustomEvent(event, {
        bubbles: false,
        composed: false,
        detail: payload,
      }),
    );
  }
}

export function setHostNode(node: Node | undefined) {
  hostNode = node;
}
